var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reset-password-app form-horizontal"},[_c('Form',{key:"ResetPassword",attrs:{"id":"ResetPassword","name":"ResetPassword","isEditing":true,"loadFormData":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }